export const ADD_IP = "ADD_IP";
export const GET_ALL_SIZE = "GET_ALL_SIZE";
export const DELETE_ALL_IPS = "DELETE_ALL_IPS";
export const HAS_IP_WITH_NAME = "HAS_IP_WITH_NAME";
export const SET_COUNT = "SET_COUNT";
